<template>
  <div class="major-hazard-detail">
    <a-breadcrumb separator=">" class="major-hazard-detail-breadcrumb">
      <a-breadcrumb-item>隐患排查台账</a-breadcrumb-item>
      <a-breadcrumb-item>
        <span @click="toPage('examine')" class="nav-page">高级审查</span>
      </a-breadcrumb-item>
      <a-breadcrumb-item>详情</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="page-content">
      <div class="con">
        <div class="content-left">
          <a-collapse
            expandIconPosition="right"
            :bordered="false"
            :defaultActiveKey="['a1', 'a2', 'a3', 'a4']"
          >
            <template slot="expandIcon" slot-scope="params">
              <div class="header-title">
                <img
                  v-show="params.isActive"
                  class="icon-close"
                  src="@/assets/images/icon_pro_item_close.png"
                />
                <img
                  v-show="!params.isActive"
                  class="icon-open"
                  src="@/assets/images/icon_pro_item_open.png"
                />
              </div>
            </template>
            <a-collapse-panel key="a1">
              <template slot="header">
                <div class="header-title">
                  <img class="icon-title" src="@/assets/images/icon_pro_shangbao.png" />
                  隐患上报
                </div>
              </template>
              <div class="panel-body">
                <div class="item">
                  <div class="label">排查人员</div>
                  <div class="value">
                    {{
                    hiddenDanger.checker == null ? "暂无" : hiddenDanger.checker
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">排查部门</div>
                  <div class="value">
                    {{
                    hiddenDanger.checksection == null
                    ? "暂无"
                    : hiddenDanger.checksection
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">所属装置</div>
                  <div class="value">
                    {{
                    hiddenDanger.zone == null
                    ? "暂无"
                    : hiddenDanger.zone
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">隐患性质</div>
                  <!--隐患性质1人的不安全行为2物的不安全状态3环境的不安全条件4管理缺陷-->
                  <div class="value">
                    {{
                    hiddenDanger.property == 1
                    ? "人的不安全行为"
                    : hiddenDanger.property == 2
                    ? "物的不安全状态"
                    : hiddenDanger.property == 3
                    ? "环境的不安全条件"
                    : hiddenDanger.property == 4
                    ? "管理缺陷"
                    : "暂无"
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">排查日期</div>
                  <div class="value">
                    {{
                      dateFormat(hiddenDanger.checktime,'YYYY-MM-DD HH:mm') || '暂无'
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">排查类别</div>
                  <!--'排查类别:1日查2周查3月查4专项排查5临时排查6二合一7督办8群众举报'-->
                  <div class="value">
                    {{
                    hiddenDanger.checktype == 1
                    ? "日查"
                    : hiddenDanger.checktype == 2
                    ? "周查"
                    : hiddenDanger.checktype == 3
                    ? "月查"
                    : hiddenDanger.checktype == 4
                    ? "专项排查"
                    : hiddenDanger.checktype == 5
                    ? "临时排查"
                    : hiddenDanger.checktype == 6
                    ? "二合一"
                    : hiddenDanger.checktype == 7
                    ? "政府督办"
                    : hiddenDanger.checktype == 8
                    ? "群众举报"
                    : "暂无"
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">隐患来源</div>
                  <!--隐患来源1企业自查，2行业主管部门检查，3中介机构检查，4群众举报-->
                  <div class="value">
                    {{
                    hiddenDanger.source == 1
                    ? "企业自查"
                    : hiddenDanger.source == 2
                    ? "行业主管部门检查"
                    : hiddenDanger.source == 3
                    ? "中介机构检查"
                    : hiddenDanger.source == 4
                    ? "群众举报"
                    : "暂无"
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">采取措施</div>
                  <div class="value">
                    {{
                    hiddenDanger.measure == 1
                    ? "就地整改"
                    : hiddenDanger.measure == 2
                    ? "上报领导"
                    : "暂无"
                    }}
                  </div>
                </div>
                <div class="item-long">
                  <div class="label">隐患描述</div>
                  <div class="value">
                    {{
                    hiddenDanger.checkdescription == null
                    ? "暂无"
                    : hiddenDanger.checkdescription
                    }}
                  </div>
                </div>

                <div class="item-half">
                  <div class="label">现场图片</div>
                  <div class="value" v-if="!hiddenDanger.checkpicture">暂无</div>
                  <div class="value" v-else>
                    <viewer>
                      <template v-for="(item,index) in pictureSrc(hiddenDanger.checkpicture)">
                        <img v-if="index<3 && item!=''" class="icon-scene" :src="item" :key="index" />
                      </template>
                    </viewer>
                  </div>
                </div>

                <div class="item audio">
                  <div class="label">语音文件</div>
                  <div class="value" v-if="!hiddenDanger.checkvoice || SoundPlayer.options.duration==0">
                    <span class="text">暂无</span>
                  </div>
                  <div
                    class="value"
                    v-else
                    @click="playMusic('hiddenDangerAudio',SoundPlayer)"
                    style="cursor: pointer;"
                  >
                    <span class="text">{{SoundPlayer.options.duration}}</span>
                    <img class="icon" :src="SoundPlayer.imgSrc" />
                  </div>
                  <audio ref="hiddenDangerAudio" v-if="isLoadV">
                    <source :src="SoundPlayer.soundSrc" type="audio/ogg" />
                  </audio>
                </div>
              </div>
            </a-collapse-panel>
            <div class="line"></div>

            <a-collapse-panel key="a2">
              <template slot="header">
                <div class="header-title">
                  <img class="icon-title" src="@/assets/images/icon_pro_fenpei.png" />
                  任务分配
                </div>
              </template>
              <div class="panel-body">
                <div class="item">
                  <div class="label">任务分配人</div>
                  <div class="value">
                    {{
                    hiddenDanger.allotor == null ? "暂无" : hiddenDanger.allotor
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">整改责任部门</div>
                  <div class="value">
                    {{
                    hiddenDanger.dealsection == null
                    ? "暂无"
                    : hiddenDanger.dealsection
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">整改期限</div>
                  <div class="value">
                     {{
                    (hiddenDanger.allottime == null || hiddenDanger.limittime == null)
                    ? "暂无"
                    : hiddenDanger.allottime.split(' ')[0]+ '至' + hiddenDanger.limittime
                    }}
                  </div>
                </div>
                <div class="item" v-if="hiddenDanger.delaytime">
                  <div class="label">延期期限</div>
                  <div class="value">{{ hiddenDanger.delaytime == null ? "暂无" : hiddenDanger.delaytime.split(' ')[0] }}</div>
                </div>

                <div class="item">
                  <div class="label">任务分配时间</div>
                  <div class="value">
                    {{
                    dateFormat(hiddenDanger.allottime, 'YYYY-MM-DD HH:mm') || '暂无'
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">整改责任人</div>
                  <div class="value">
                    {{
                    hiddenDanger.handler == null ? "暂无" : hiddenDanger.handler
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">验收人</div>
                  <div class="value">
                    {{
                    hiddenDanger.examiner == null
                    ? "暂无"
                    : hiddenDanger.examiner
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">隐患等级</div>
                  <div class="value">
                    {{
                    hiddenDanger.level == 1
                    ? "一般"
                    : hiddenDanger.level == 2
                    ? "重大"
                    : "暂无"
                    }}
                  </div>
                </div>
                <div class="item-long">
                  <div class="label">整改措施</div>
                  <div class="value">
                    {{
                    hiddenDanger.dealmeasure == null
                    ? "暂无"
                    : hiddenDanger.dealmeasure
                    }}
                  </div>
                </div>
                <div class="item-long">
                  <div class="label">整改要求</div>
                  <div class="value">
                    {{
                    hiddenDanger.handdemand == null
                    ? "暂无"
                    : hiddenDanger.handdemand
                    }}
                  </div>
                </div>
              </div>
            </a-collapse-panel>
            <div class="line"></div>

            <a-collapse-panel key="a3">
              <template slot="header">
                <div class="header-title">
                  <img class="icon-title" src="@/assets/images/icon_pro_zhenggai.png" />
                  整改落实
                </div>
              </template>
              <div class="panel-body">
                <div class="item">
                  <div class="label">整改完成日期</div>
                  <div class="value">
                    {{
                    dateFormat(hiddenDanger.donetime) || '暂无'
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">整改资金（元）</div>
                  <div class="value">{{ hiddenDanger.funds == null ? "暂无" : hiddenDanger.funds }}</div>
                </div>
                <div class="item-half"></div>
                <div class="item-half">
                  <div class="label">整改后图片</div>
                  <div class="value" v-if="!hiddenDanger.donepicture">暂无</div>
                  <div class="value" v-else>
                    <viewer>
                      <template v-for="(item,index) in pictureSrc(hiddenDanger.donepicture)">
                        <img v-if="index<3 && item!=''" class="icon-scene" :src="item" :key="index" />
                      </template>
                    </viewer>
                  </div>
                </div>
                <div class="item-long">
                  <div class="label">整改措施及应急方案</div>
                  <div class="value">
                    {{
                    hiddenDanger.dealmeasure == null
                    ? "暂无"
                    : hiddenDanger.dealmeasure
                    }}
                  </div>
                </div>
              </div>
            </a-collapse-panel>
            <div class="line"></div>

            <a-collapse-panel key="a4">
              <template slot="header">
                <div class="header-title">
                  <img class="icon-title" src="@/assets/images/icon_pro_yanshou.png" />
                  验收销号
                </div>
              </template>
              <div class="panel-body">
                <div class="item">
                  <div class="label">验收人</div>
                  <div class="value">
                    {{
                    hiddenDanger.examiner == null
                    ? "暂无"
                    : hiddenDanger.examiner
                    }}
                  </div>
                </div>
                <!-- <div class="item">
                  <div class="label">验收结论</div>
                  <div class="value">
                    {{
                    hiddenDanger.examinecondition == null
                    ? "暂无"
                    : hiddenDanger.examinecondition
                    }}
                  </div>
                </div> -->
                <div class="item">
                  <div class="label">验收时间</div>
                  <div class="value">
                    {{
                    dateFormat(hiddenDanger.examinetime,'YYYY-MM-DD HH:mm') || '暂无'
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">所属工序</div>
                  <div class="value">
                    {{
                    hiddenDanger.process == null ? "暂无" : hiddenDanger.process
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">隐患类别</div>
                  <div class="value">
                    {{
                    hiddenDanger.type == null
                    ? "暂无"
                    : hiddenDanger.type.split("##")[0]
                    }}
                    /
                    {{
                    hiddenDanger.type == null
                    ? "暂无"
                    : hiddenDanger.type.split("##")[1]
                    }}/
                    {{
                    hiddenDanger.type == null
                    ? "暂无"
                    : hiddenDanger.type.split("##")[2]
                    }}
                  </div>
                </div>
                <div class="item-long">
                  <div class="label">验收情况</div>
                  <div class="value">
                    {{
                    hiddenDanger.examinecondition == null
                    ? "暂无"
                    : hiddenDanger.examinecondition
                    }}
                  </div>
                </div>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>

        <right-process class="content-right" :processData="processData"></right-process>
      </div>
    </div>
    <a-spin :spinning="isLoad" v-show="isLoad" class="spinning-load" />
  </div>
</template>
<script>
import rightProcess from "@/components/rightProcess.vue";
import moment from "moment";
// 重大危险源-详情
export default {
  components: {
    "right-process": rightProcess
  },
  data() {
    return {
      isLoad: false,
      isLoadV: true,
      processData: [],
      moment,
      hiddenDanger: {},
      SoundPlayer: {
        // 音乐相关配置
        options: {
          isOpen: true,
          duration: 0
        },
        soundSrc: require("@/assets/images/music01.mp3"),
        imgSrc: require("@/assets/images/pro_sound_3.png"),
        imgSrcList: [
          require("@/assets/images/pro_sound_3.png"),
          require("@/assets/images/pro_sound_2.png"),
          require("@/assets/images/pro_sound.png")
        ],
        // 播放音乐定时器
        setImageInInterval: null
      }
    };
  },
  mounted() {
    this.query(this.$store.state.query.id);
  },
  methods: {
    pictureSrc(srcStr) {
      let srcArr = [];
      srcArr = srcStr.split("##");
      return srcArr;
    },
    //查询当前页的数据
    query(val) {
      let _this = this;
      // 请求对象
      let params = new URLSearchParams();
      // 填充参数
      params.append("id", val);
      _this.isLoad = true;
      _this
        .$axios({
          url: "/pc/hiddenDanger/selectHiddenDangerById",
          method: "get",
          params: params
        })
        .then(res => {
          console.log("===", res);
          this.hiddenDanger = res.data.data;
          this.processData = res.data.log;

          this.$set(this.SoundPlayer, "soundSrc", this.hiddenDanger.checkvoice);
          this.isLoadV = false;
          this.isLoadV = true;
          this.$nextTick(() => {
            let node = this.$refs["hiddenDangerAudio"];
            node.load();
            node.addEventListener("canplaythrough", () => {
              this.SoundPlayer.options.duration = parseInt(node.duration);
            });
          });
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          _this.isLoad = false;
        });
    },
    // 跳转页面
    toPage: function(routeName) {
      this.$router.push({ name: routeName });
    },

    playMusic(domId, datas) {
      let node = this.$refs[domId];
      let i = 0;
      if (node.ended || node.paused) {
        node.play();
        datas.setImageInInterval = setInterval(() => {
          i++;
          if (i % 3 == 1) {
            datas.imgSrc = datas.imgSrcList[0];
          } else if (i % 3 == 2) {
            datas.imgSrc = datas.imgSrcList[1];
          } else {
            datas.imgSrc = datas.imgSrcList[2];
          }
        }, 300);

        node.addEventListener("ended", function() {
          window.clearInterval(datas.setImageInInterval);
        });
      } else {
        node.load();
        if (datas.setImageInInterval) {
          window.clearInterval(datas.setImageInInterval);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.major-hazard-detail::v-deep {
  .spinning-load {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  height: 100%;

  display: flex;
  flex-direction: column;

  .major-hazard-detail-breadcrumb {
    height: 50px;
    background-color: rgba(235, 245, 255, 1);
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 50px;
    color: rgb(51, 97, 143);
    text-align: left;
    padding: 0 20px;
  }

  .page-content {
    height: calc(100% - 50px);
    flex: 1;
    overflow-y: auto;

    .con {
      display: flex;
      padding: 10px;
      padding-bottom: 30px;
    }

    .content-left {
      flex: 1;
      margin-right: 10px;
    }
    .content-right {
      background-color: #fff;
      height: auto;
    }
  }

  .ant-collapse {
    border: none;
    background-color: #fff;
    .ant-collapse-item {
      border: none;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 5px 0px 6px rgba(108, 115, 146, 0.15);
      .ant-collapse-header {
        text-align: left !important;
        height: 40px;
        line-height: 40px;
        padding: 0 0 0 30px;
        background: rgba(85, 167, 141, 0.1);
        color: rgba(85, 167, 141, 1);
        font-weight: bold;
        text-indent: 1.5em;
        .icon-close {
          width: 16px;
          height: 2px;
        }
        .icon-open {
          width: 16px;
          height: 16px;
        }
        .header-title {
          display: flex;
          align-items: center;
          .icon-title {
            width: 14px;
            height: 14px;
            margin-right: 5px;
          }
        }
      }
      .ant-collapse-content {
        background-color: #fff;
      }
    }
  }

  .line {
    height: 10px;
    background-color: rgba(240, 242, 245, 1);
  }

  .panel-body {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    .item {
      height: 100px;
      width: 25%;
      padding: 20px;
      .label,
      .value {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        &.label {
          color: rgba(51, 97, 143, 1);
        }
        &.value {
          background-color: rgba(114, 190, 255, 0.13);
          border-radius: 4px;
          text-indent: 0.5em;
        }
      }

      &.audio {
        .value {
          height: 28px;
          background-color: rgba(85, 167, 141, 1);
          border-radius: 5px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          user-select: none;
          .text {
            color: #fff;
          }
          .icon {
            width: 15px;
            height: 15px;
            margin-right: 20px;
          }
        }
      }
    }
    .item-half {
      width: 50%;
      padding: 20px;
      .label {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        color: rgba(51, 97, 143, 1);
      }
      .value {
        background-color: rgba(114, 190, 255, 0.13);
        border-radius: 4px;
        padding: 10px;
        .icon-scene {
          width: 170px;
          height: 110px;
          margin-left: 10px;
        }
      }
    }

    .item-long {
      width: 100%;
      padding: 20px;
      .label {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        color: rgba(51, 97, 143, 1);
      }

      .value {
        padding: 20px;
        font-size: 16px;
        background-color: rgba(114, 190, 255, 0.13);
        border-radius: 4px;
        min-height: 100px;
      }
    }
  }
}
</style>
